export default __webpack_public_path__ + "media/images/nav-logo-b73c6333.svg";